angular.module('impactx.analytics', []);